import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import CopyToClipboard from 'react-copy-to-clipboard'

import { Tooltip } from 'react-tippy'

import xhr from '../utils/xhr'
import { withAppContext } from '../utils/AppContext'
import Icon from './Icon'

import styles from '../scss/ui/share.scss'

class Share extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            shareURL: '',
            copied: false,
        }
        this.setCopied = this.setCopied.bind(this)
    }

    componentDidMount() {
        const { appContext } = this.props
        if (!appContext.list.length) {
            this.setState({ shareURL: 'https://winteriscoming.net/media/build-your-own-small-council' })
        } else {
            xhr.post('/wp-json/rankers/v1/gameofthrones/save', {
                data: appContext.scoreCalculator.getSaveData(),
            })
                .then(response => {
                    if (window.location.search) {
                        const url = new URL(window.location.href)
                        this.setState({ shareURL: `${url.origin}${url.pathname}?id=${response.hash}` })
                    } else {
                        this.setState({ shareURL: `${window.location.href}?id=${response.hash}` })
                    }
                })
                .catch(e => console.log(e))
        }
    }

    setCopied() {
        this.setState({ copied: true }, () => {
            setTimeout(() => {
                this.setState({ copied: false })
            }, 2000)
        })
    }

    render() {
        const { appContext } = this.props
        const { shareURL, copied } = this.state
        const shareText = encodeURIComponent(
            'Check out my Game of Thrones Small Council and build your own. From @WiCnet. #GoTSmallCouncil',
        )
        const shareTextBody = encodeURIComponent(
            `Check out my Game of Thrones Small Council at ${shareURL} or make your own at WinterIsComing.net`,
        )

        return (
            <div className={styles.share}>
                <div className={cx(styles.shareCenter, 'vertical-middle center-content')}>
                    <button
                        onClick={() => appContext.toggleShareLightboxOff()}
                        type="button"
                        className={styles.xIconButton}
                    />
                    <Icon icon="x" size={2} color="white" className={styles.xIcon} />
                    <h2>Share Your List</h2>
                    <div className={styles.iconContainer}>
                        <a
                            href={`https://www.facebook.com/sharer.php?u=${shareURL}&t=${shareText}`}
                            target="_blank"
                            rel="noopener noreferrer">
                            <Icon icon="facebook" size={4} color="white" className={styles.icons} />
                        </a>
                        <a
                            href={`https://twitter.com/intent/tweet?text=${shareText}&url=${shareURL}`}
                            target="_blank"
                            rel="noopener noreferrer">
                            <Icon icon="twitter" size={4} color="white" className={styles.icons} />
                        </a>
                        <a
                            href={'mailto:?subject=Check out my Game of Thrones Small Council&body=Check out the Game' +
                            ` of Thrones Small Council I built and build your own at ${shareURL}`}
                            title="Share by Email"
                            target="_blank"
                            rel="noopener noreferrer">
                            <Icon icon="email" size={4} color="white" className={styles.icons} />
                        </a>
                    </div>
                    <div className={cx(styles.input, 'horizontal-owl-medium')}>
                        <input type="text" value={shareURL} onChange={() => {}} />
                        <CopyToClipboard text={shareURL} onCopy={this.setCopied}>
                            <button type="button">
                                <Tooltip
                                    hideOnClick={false}
                                    title={copied ? 'Copied!' : 'Click to Copy'}
                                    position="top"
                                    trigger="mouseenter"
                                    arrow="true">
                                    <Icon icon="link" size={3.1} color="white" className={styles.icons} />
                                </Tooltip>
                            </button>
                        </CopyToClipboard>
                    </div>
                    <p>
                        Copy this URL or use one of the buttons above to save or share your Small Council with friends
                        or yourself.
                    </p>
                </div>
            </div>
        )
    }
}

Share.propTypes = {
    appContext: PropTypes.object.isRequired,
}

export default withAppContext(Share)



// WEBPACK FOOTER //
// ./src/ui/Share.js